import React from "react";
import "./AdminDashboardHome.css";

// "Project Health" row/card (Admin Command Centre redesign). No "Members"
// count -- tasks don't carry a project-membership list anywhere in this
// app's data, so it's omitted rather than fabricated.
export default function ProjectHealthCard({ name, openCount, completedCount, overdueCount, completionPct, onClick }) {
  return (
    <button type="button" className="adh-project-card" onClick={onClick}>
      <div className="adh-project-top">
        <span className="adh-project-name">{name}</span>
        <span className="adh-project-pct">{completionPct}% complete</span>
      </div>
      <div className="adh-project-track">
        <div className="adh-project-fill" style={{ width: `${completionPct}%` }} />
      </div>
      <div className="adh-project-counts">
        <span>{openCount} open</span>
        <span className={overdueCount > 0 ? "adh-project-overdue" : ""}>{overdueCount} overdue</span>
        <span>{completedCount} completed</span>
      </div>
    </button>
  );
}
